<template>
    <div class="patient-item" @click="openPatient(index)" :class="patient.state.name === 'waiting' ? 'waiting' : patient.state.name === 'other' ? 'other' : patient.state.name === 'avd' ? 'avd' : ''">
        <div class="icon">
            <div class="color-point" :class="patient.isDoctorSetAvd ? 'yellow' : 'red'" v-if="patient.state.name === 'waiting'"></div>
            <img :src="`${publicPath}` + patient.patientsImage.shortImage" alt="patient icon" v-if="patient.state.name === 'waiting'">
            <img :src="`${publicPath}` + patient.patientsImage.shortImage" alt="patient icon" v-else>
        </div>
        <div class="text-content">
            <div class="title">Паціент</div>
            <div class="name">{{patient.name}}</div>
        </div>
    </div>
</template>

<script>
export default {
    props : ['patient', 'index'],
    data : () => ({
        publicPath: process.env.BASE_URL
    }),
    methods : {
        openPatient(index){
            console.log(index);
            this.$router.push('/patient/' + index);
        }
    }
}
</script>

<style lang="scss">
.patient-item{
    display: flex;
    flex-direction: row;
    align-items: center;

    border-radius: 100px;

    padding: 0.833vw 1.667vw 0.938vw;

    cursor: pointer;

    .icon{
        margin-right: 0.833vw;
        border-radius: 50%;
        width: 4.167vw;

        img{
            width: 4.167vw;
        }

        position: relative;

        .color-point{
            position: absolute;
            right: 0;
            z-index: 10;

            width: 0.781vw;
            height: 0.781vw;
            border-radius: 50%;
        }

        .red{
            background: #B30037;
        }

        .yellow{
            background: #F9A900;
            border: 1px solid #B0A197;
        }
    }

    .text-content{
        display: flex;
        flex-direction: column;
        align-items: flex-start;

        .title{
            font-style: normal;
            font-weight: 500;
            font-size: 0.938vw;
        }

        .name{
            font-weight: 750;
            font-size: 1.250vw;
            line-height: 2.500vw;
        }
    }
}

.waiting{
    background: #DADADA;
    box-shadow: 4px 4px 20px rgba(0, 0, 0, 0.15);

    padding: 0.938vw 1.667vw 1.042vw;

    .icon{
        background: #C4C4C4;

        img{
            filter: grayscale(100%);
        }
    }

    .text-content{
        .title{
            color: #494949;
            opacity: 0.7;
        }

        .name{
            color: #494949;
        }
    }
}

.other{
    background: #ABA88F;

    border: 2px solid #575A5D;
    box-sizing: border-box;

    .icon{
        background: #C4C4C4;
    }

    .text-content{
        .title{
            color: #FFFFFF;
        }

        .name{
            color: #FFFFFF;
        }
    }
}

.avd{
    background: linear-gradient(270.26deg, #F9A900 -3.19%, #FF7DA5 146.23%);

    border: 2px solid #575A5D;
    box-sizing: border-box;

    .icon{
        background: #FDB387;
    }

    .text-content{
        .title{
            color: #FFFFFF;
        }

        .name{
            color: #FFFFFF;
        }
    }
}
</style>